import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import GoogleSignIn from '../GoogleSignIn/GoogleSignIn';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, signIn } = useAuth();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <LoadingSpinner size="large" text="Carregando..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <GoogleSignIn onSignIn={signIn} />;
  }

  return children;
};

export default ProtectedRoute;
